import { embedCover } from "@blocks/atonal-video-embed/view";
import FetchModalBasedOnAnchor from "@resources/fetch-modal-based-on-anchor/FetchModalBasedOnAnchor";
import SizeObserverCssVariables from "@resources/size-observer-css-variables/SizeObserverCssVariables";

window.addEventListener('load', () => {
	let modalId = 'single-video-modal';
	let videoSingleSel = '.content--template-single-video';
	let videoHolderSel = '.atonal-video-embed[data-block-prev=first-of-root] > div'
	videoHolderSel = `${videoSingleSel} ${videoHolderSel}, #${modalId} ${videoHolderSel}`
	const videoSizeObserver = new SizeObserverCssVariables("single-video", videoHolderSel);
	videoSizeObserver.setVideoHeightObserver()

	FetchModalBasedOnAnchor.registerFetch(
		'fetch',
		'single-video',
		'single-video-modal',
		'single-fetch-modal single-fetch-modal--single-video',
		'#main',
		'.single-fetch-modal--single-video .back-button',
		() => {
			videoSizeObserver.setVideoHeightObserver()
			embedCover.reindex();
		},
	)
})


